import React from "react";
import { useModelFilterSelector } from "../../../../redux/store";
import * as Styles from "./styles/FilterResultCountStyles";
import { useModelFilterLabel } from "../../../../utils/labels";

type FilterResultCountType = { show: boolean };
const FilterResultCount = (props: FilterResultCountType): JSX.Element => {
    const { show } = props;
    const resultCount = useModelFilterSelector((state) => state.modelResults.totalResultCount);
    const modelsCount = useModelFilterSelector((state) => state.modelResults.results.length);
    const initialized = useModelFilterSelector((state) => state.modelResults.initialized);

    const modelsCountLabel = useModelFilterLabel("modelsCount");
    const resultCountLabel = useModelFilterLabel("resultCount");

    // Split the modelsCountLabel and resultCountLabel so we can apply styling to the count number.
    const modelsCountLabelSplit = modelsCountLabel.split("{value}");
    const resultCountLabelSplit = resultCountLabel.split("{value}");

    return (
        <Styles.Wrapper show={show && initialized}>
            <div>
                <Styles.PreCount>{modelsCountLabelSplit[0]}</Styles.PreCount>
                <Styles.Count>{modelsCount}</Styles.Count>
                <Styles.Label>{modelsCountLabelSplit[1]}</Styles.Label>
            </div>
            <div>
                <Styles.Label>{`${resultCountLabelSplit[0]}${resultCount} ${resultCountLabelSplit[1]}`}</Styles.Label>
            </div>
        </Styles.Wrapper>
    );
};

export default FilterResultCount;
